import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconArrowUp: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M10.0003 15.8333V4.16663M10.0003 4.16663L4.16699 9.99996M10.0003 4.16663L15.8337 9.99996"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconArrowUp.defaultProps = defaultIconProps;
